import { BasicService } from "@/services/basic";
import { createGetUrlWithOptions } from "@/helpers/services";
export class Employees extends BasicService {
    constructor(axios) {
        super(axios);
        this.baseURL = "employees";
    }
    async get(options) {
        try {
            const url = createGetUrlWithOptions(this.baseURL, options);
            const { data } = await this.$get(url);
            return Promise.resolve(data);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async add(employees) {
        try {
            await this.$post(this.baseURL, employees);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async edit(employees) {
        try {
            await this.$put(`${this.baseURL}/${employees.id}`, employees);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async delete(employeesId) {
        try {
            await this.$delete(`${this.baseURL}/${employeesId}`);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
